import { Body1, Display2 } from '@sainsburys-tech/luna-typography'
import { IText } from '../../../../../types/ComponentTypes/Components'

function TextComponent({ label, value, style }: IText) {
  const styleMap: Record<string, string | undefined> = {
    'summary-text': 's-summary-text',
    'summary-text-title': 's-summary-text-title',
    'center': 's-text-align-center',
  };

  const mappedStyle = styleMap[style] || undefined;

  return (
    <>
      {label && (
        <Display2
          id="s-reporting-text-title"
          className={mappedStyle}
          element="h6"
          label={label}
        >
          {label}
        </Display2>
      )}
      {value && (
        style === 'summary-text-title' ? (
          <div id="s-reporting-text-body-title" className={mappedStyle}>
            {value}
          </div>
        ) : (
          <Body1 id="s-reporting-text-body" className={mappedStyle} element="p">
            {value}
          </Body1>
        )
      )}
    </>
  )
}

export default TextComponent
